export function calcularPreco(modalidadePesca) {
  if (modalidadePesca === 0) {
    return "90,38";
  } else if (modalidadePesca === 1) {
    return "119,00";
  }
  return "0,00";
}
